<template>
    <div class="Explore-button"     
    >
        <v-btn 
        class="explore-btn midnightButton buttonBranding_midnight"  
        rounded
        @click="changeFocusMode"
        :ripple="false"
        flat
        >
            <span class="buttonText">Explore more</span>
            <!-- <v-icon class="icon" right>mdi-magnify</v-icon> -->
        </v-btn>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.explore-btn {
    background-color: #2E2E2E; /* Adjust this color as needed */
    color: white;
    padding: 25px 25px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    
    /* Font */

    font-family: 'GCO Sans' !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.8px;
    text-align: left;

    text-transform: none;

    cursor: pointer;

    letter-spacing: 0.48px;
}

.explore-btn span{
    line-height: 2px;
}

</style>